import { render, staticRenderFns } from "./MainHeaderIntroLogoMasked.vue?vue&type=template&id=723b8a4b&scoped=true"
import script from "./MainHeaderIntroLogoMasked.vue?vue&type=script&lang=js"
export * from "./MainHeaderIntroLogoMasked.vue?vue&type=script&lang=js"
import style0 from "./MainHeaderIntroLogoMasked.vue?vue&type=style&index=0&id=723b8a4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723b8a4b",
  null
  
)

export default component.exports